export const EMPTY_LIST_TITLE = 'No Auction Items Yet';
export const EMPTY_FILTERED_LIST_DESCRIPTION =
  'You have not added any auction items.';
export const EMPTY_LIST_DESCRIPTION =
  'Stay tuned for new auction items to be added or click below to add your own.';
